import requests from 'app/requests/ContainerUnitPriceRule.requests'
import ProformaInvoiceForm from '../ProformaInvoiceForm'

export default function ProformaInvoiceCreate({
    onSuccess,
}: Readonly<{
    onSuccess: (a: any) => void
}>) {
    return (
        <ProformaInvoiceForm
            onSuccess={onSuccess}
            requestParam={requests.create()}
        />
    )
}
